<template>
  <section class="content-panel">
    <div class="section-head">
      <div>
        <h2>风控记录</h2>
        <p>设备访问审核结果及风险原因</p>
      </div>
      <el-tag type="info" effect="plain">共 {{ admin.riskPagination.total }} 条</el-tag>
    </div>

    <div class="filter-bar risk-filters">
      <CustomerRemoteSelect
        v-model="admin.riskFilters.customerId"
        :token="admin.token.value"
        placeholder="选择客户"
        width="220px"
        @change="onFilterChange"
        @select="onCustomerSelect"
      />
      <el-input
        v-model="admin.riskFilters.deviceId"
        placeholder="设备 ID"
        clearable
        class="search-input"
        style="width: 260px"
        @clear="onFilterChange"
        @keyup.enter="onFilterChange"
      >
        <template #append>
          <el-button @click="onFilterChange">搜索</el-button>
        </template>
      </el-input>
    </div>

    <el-table :data="admin.riskLogs.value" stripe>
      <el-table-column type="index" label="#" width="56" />
      <el-table-column label="客户" min-width="140">
        <template #default="{ row }">{{ admin.customerName(row.customerId) }}</template>
      </el-table-column>
      <el-table-column prop="deviceId" label="设备" min-width="180" show-overflow-tooltip />
      <el-table-column label="审核结果" width="110">
        <template #default="{ row }">
          <el-tag :type="row.passed === 1 ? 'success' : 'danger'" effect="light">
            {{ row.passed === 1 ? '通过' : '未通过' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="reasonCode" label="原因码" width="120" />
      <el-table-column prop="reasonMessage" label="风险原因" min-width="200" show-overflow-tooltip />
      <el-table-column prop="createdAt" label="发生时间" min-width="180" />
      <template #empty><el-empty description="暂无风控记录" /></template>
    </el-table>

    <div class="panel-footer">
      <el-pagination
        v-model:current-page="admin.riskPagination.page"
        v-model:page-size="admin.riskPagination.size"
        :total="admin.riskPagination.total"
        :page-sizes="[20, 50, 100]"
        layout="total, sizes, prev, pager, next"
        background
        @current-change="onPageChange"
        @size-change="onSizeChange"
      />
    </div>
  </section>
</template>

<script setup>
import { inject } from 'vue'
import CustomerRemoteSelect from '@/components/CustomerRemoteSelect.vue'

const admin = inject('admin')

function onCustomerSelect(item) {
  if (item) admin.rememberCustomers([item])
}

function onFilterChange() {
  admin.riskPagination.page = 1
  admin.loadRiskLogs(1)
}

function onPageChange(page) {
  admin.loadRiskLogs(page)
}

function onSizeChange(size) {
  admin.loadRiskLogs(1, size)
}
</script>

<style scoped>
.risk-filters {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}
</style>
